import React from "react";
import { Descriptions, Modal, Select, Spin } from "antd";
import { TModalSelectStore } from "./types";
import useModalSelectStore from "./useModalSelectStore";
import DSButton from "../../../../../components/DSButton";
import designSystemColors from "../../../../../styles";

const { Option } = Select;

const ModalSelectStore: React.FC<TModalSelectStore> = ({
  open,
  changeOpenState,
  closeModal,
  userStores,
  annuity,
  selectedRowKeys,
  reloadPremiumAnnuity,
}) => {
  const {
    loading,
    stores,
    selectedStore,
    handleSelectChange,
    handleEngage,
    loadingAnnuity,
  } = useModalSelectStore({
    open,
    closeModal,
    userStores,
    annuity,
    selectedRowKeys,
    reloadPremiumAnnuity,
  });

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      title="Selecionar Loja Para Anuidade"
      closable={!loadingAnnuity}
      maskClosable={!loadingAnnuity}
      keyboard={!loadingAnnuity}
    >
      <Spin spinning={loading}>
        <Select
          value={selectedStore}
          onChange={(value) => handleSelectChange(value)}
          style={{ width: "100%" }}
          placeholder="Selecione uma loja"
          loading={loading}
          disabled={loading}
        >
          {stores.map((loja, index) => (
            <Option key={loja.id || index} value={loja.id}>
              <Descriptions column={1} size="small" layout="horizontal">
                {loja.nomeFantasia && (
                  <Descriptions.Item
                    label="Nome Fantasia"
                    span={1}
                    labelStyle={{ fontWeight: 700 }}
                  >
                    {loja.nomeFantasia}
                  </Descriptions.Item>
                )}
                <Descriptions.Item
                  label="Razão Social"
                  span={1}
                  labelStyle={{ fontWeight: 700 }}
                >
                  {loja.razaoSocial}
                </Descriptions.Item>
              </Descriptions>
            </Option>
          ))}
        </Select>
      </Spin>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginTop: "2rem",
        }}
      >
        <DSButton
          key="cancel"
          isCancelType
          buttonText="Cancelar"
          onClick={changeOpenState}
          buttonType="primary"
          disabled={loadingAnnuity}
          isDisabled={loadingAnnuity}
          style={{
            height: 40,
            padding: "0rem 1rem",
          }}
        />

        <DSButton
          key="submit"
          onClick={handleEngage}
          buttonText="Contratar"
          buttonType="primary"
          disabled={loadingAnnuity || !selectedStore}
          isDisabled={loadingAnnuity || !selectedStore}
          isLoading={loadingAnnuity}
          dataTestId="button-submit-annuity-with-store"
          style={{
            border: "none",
            backgroundColor: designSystemColors.generalButtons,
            height: 40,
            padding: "0rem 1rem",
          }}
        />
      </div>
    </Modal>
  );
};

export default ModalSelectStore;
